import { EXPORT_SHOW_UPSELL_DIALOG } from './constants'

export function showUpsellDialog() {
    return {
        type: EXPORT_SHOW_UPSELL_DIALOG,
    }
}
